import React, { useEffect, useState } from 'react';
import { Users, Star, Award } from 'lucide-react';

const ICON_MAP = {
  users: <Users size={32} className="text-kenya-orange" />,
  star: <Star size={32} className="text-kenya-orange" />,
  award: <Award size={32} className="text-kenya-orange" />,
};

const AboutPage = () => {
  const [about, setAbout] = useState(null);

  useEffect(() => {
    fetch('https://python.rock-safaris.com/about/')
      .then(res => res.json())
      .then(data => setAbout(data));
  }, []);

  if (!about) {
    return (
      <div className="container text-center py-5">
        <div className="spinner-border text-kenya-orange" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div>
      {/* Hero Section */}
      <section className="bg-kenya-yellow py-5">
        <div className="container text-center py-4">
          <h1 className="display-5 fw-bold text-kenya-brown mb-3">
            {about.hero_title || 'About Pride Rock Tours & Safaris'}
          </h1>
          <p className="lead text-kenya-brown mx-auto" style={{ maxWidth: 700 }}>
            {about.hero_description}
          </p>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-5 bg-kenya-white">
        <div className="container">
          <div className="row g-4">
            <div className="col-md-6">
              <div className="card shadow border-0 h-100">
                <div className="card-body">
                  <h2 className="fw-bold text-kenya-orange mb-3">Our Mission</h2>
                  <p>{about.mission}</p>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card shadow border-0 h-100">
                <div className="card-body">
                  <h2 className="fw-bold text-kenya-orange mb-3">Our Vision</h2>
                  <p>{about.vision}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Objective */}
      <section className="py-5">
        <div className="container text-center">
          <div className="mx-auto" style={{ maxWidth: 700 }}>
            <h2 className="fw-bold text-kenya-brown mb-3">Our Objective</h2>
            <p>{about.objective}</p>
          </div>
        </div>
      </section>

      {/* Team Values */}
      <section className="py-5 bg-kenya-white">
        <div className="container">
          <h2 className="text-center fw-bold text-kenya-brown mb-5">What Sets Us Apart</h2>
          <div className="row g-4">
            {about.team_values && about.team_values.map((value, idx) => (
              <div className="col-md-4 text-center" key={idx}>
                <div className="mb-3">
                  <span className="bg-kenya-yellow rounded-circle d-inline-flex align-items-center justify-content-center" style={{ width: 64, height: 64 }}>
                    {ICON_MAP[value.icon] || <Users size={32} className="text-kenya-orange" />}
                  </span>
                </div>
                <h5 className="fw-semibold mb-2">{value.title}</h5>
                <p>{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;